module.exports = __webpack_public_path__ + "img/protocols.dc99576a.svg";